import { createSlice } from "@reduxjs/toolkit";
import { normalizeRmsConfig } from "utils/refundConfig";

const initialState = {
  rmsConfig: {},
  merchantConfig: {},
};

const resolveGoogleFontFamily = (merchantConfig = {}) => {
  const configuredFont =
    merchantConfig?.public_page_theme_configurations?.google_font_family ??
    merchantConfig?.google_font_family;
  const normalizedFont =
    typeof configuredFont === "string" ? configuredFont.trim() : configuredFont;

  return normalizedFont || "Inter";
};

const PUBLIC_PAGE_THEME_KEYS = [
  "favicon",
  "brand_logo",
  "brand_cover_image",
  "cover_image_width",
  "google_font_family",
  "primary_theme_color",
  "login_section_opacity",
  "secondary_theme_color",
  "login_section_position",
  "use_rounded_edge_buttons",
  "cover_image_visible_in_mobile",
  "cover_image_visible_in_desktop",
  "login_section_brand_logo_visible_in_mobile",
  "login_section_brand_logo_visible_in_desktop",
];

const normalizeMerchantConfig = (merchantConfig = {}) => {
  const publicPageTheme =
    merchantConfig?.public_page_theme_configurations &&
    typeof merchantConfig.public_page_theme_configurations === "object"
      ? merchantConfig.public_page_theme_configurations
      : {};

  const normalizedTheme = PUBLIC_PAGE_THEME_KEYS.reduce((acc, key) => {
    if (
      publicPageTheme[key] !== undefined &&
      publicPageTheme[key] !== null &&
      publicPageTheme[key] !== ""
    ) {
      acc[key] = publicPageTheme[key];
    }

    return acc;
  }, {});

  return {
    ...merchantConfig,
    ...normalizedTheme,
    shopify_domain: merchantConfig.shopify_domain || merchantConfig.domain || "",
    google_font_family: resolveGoogleFontFamily({
      ...merchantConfig,
      ...normalizedTheme,
    }),
  };
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    addRmsConfig: (state, { payload }) => {
      state.rmsConfig = normalizeRmsConfig(payload);
    },
    addMerchantConfig: (state, { payload }) => {
      const normalizedPayload = normalizeMerchantConfig(payload);
      // Only update if the payload is different from the current state
      if (
        JSON.stringify(state.merchantConfig) !==
        JSON.stringify(normalizedPayload)
      ) {
        state.merchantConfig = normalizedPayload;
      }
    },
  },
});

export const { addRmsConfig, addMerchantConfig } = configSlice.actions;

// RMS Config
export const getRmsConfig = (state) => state.configReducer.rmsConfig;

// Merchant Config
export const getMerchantConfig = (state) => state.configReducer.merchantConfig;

export default configSlice.reducer;
